import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';

import BaseAntiSpam from '../../AbstractObjects/GatewayPlan/InnerPages/BaseAntiSpam';
import {useTranslation} from 'react-i18next';
import Indentation from '../../../../components/Simple/Indentation';
import SMCLink from '../../../../components/Simple/SMCLink';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {doSeamlessLogin} from '../../../../utils/utils';
import {antiSpamIcon} from "../../../../assets/images/headerIcons";

const pageSchema = GatewayGetSchema.pages.antiSpam;
const pageId = pageSchema.pageId;

function AntiSpam({
    gatewayObject,
    planObject,
    setGatewayData
}) {
    const { t } = useTranslation();

    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setGatewayData([pageId, pageSchema.manageInSmp], planPage[pageSchema.manageInSmp]);
            setGatewayData([pageId, pageSchema.mode], planPage[pageSchema.mode]);
            setGatewayData([pageId, pageSchema.contentBasedFilter], planPage[pageSchema.contentBasedFilter]);
            setGatewayData([pageId, pageSchema.spamAction], planPage[pageSchema.spamAction]);
            setGatewayData([pageId, pageSchema.track], planPage[pageSchema.track]);
            setGatewayData([pageId, pageSchema.detectOnly], planPage[pageSchema.detectOnly]);
            setGatewayData([pageId, pageSchema.spamEmailSubject], planPage[pageSchema.spamEmailSubject]);
        }
        setGatewayData([pageId, pageSchema.lockedToPlan], locked);

    }, [setGatewayData, planPage]);


    return (
        <>
        <LockToPlanContainer
            locked={lockedToPlan}
            onToggleLocked={onToggleLockedToPlan}
            labelText={t('SMC_TEMPLATE_ANTI_SPAM')}
            icon={antiSpamIcon}
        >
            <BaseAntiSpam
                pageData={currentPageData}
                setObjectData={setGatewayData}
                pageDisabled={lockedToPlan}
            />
        </LockToPlanContainer>
        <Indentation>
            <SMCLink onClick={() => doSeamlessLogin(gatewayObject.id, null, 'app.AntiSpamPolicy')}><SMCIcon style={{ verticalAlign: 'middle' }} icon="seamlessLogin" /> {t('SMP.ACCESS_GATEWAY.ANTI_SPAM')}</SMCLink>
        </Indentation>
        </>
    );
}

export default AntiSpam;